"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ThemeContext_unstable: function() {
        return _ThemeContext.ThemeContext;
    },
    ThemeProvider_unstable: function() {
        return _ThemeContext.ThemeProvider;
    },
    ThemeClassNameProvider_unstable: function() {
        return _ThemeClassNameContext.ThemeClassNameProvider;
    },
    useThemeClassName_unstable: function() {
        return _ThemeClassNameContext.useThemeClassName;
    },
    TooltipVisibilityProvider_unstable: function() {
        return _TooltipVisibilityContext.TooltipVisibilityProvider;
    },
    useTooltipVisibility_unstable: function() {
        return _TooltipVisibilityContext.useTooltipVisibility;
    },
    Provider_unstable: function() {
        return _ProviderContext.Provider;
    },
    useFluent_unstable: function() {
        return _ProviderContext.useFluent;
    },
    OverridesProvider_unstable: function() {
        return _OverridesContext.OverridesProvider;
    },
    useOverrides_unstable: function() {
        return _OverridesContext.useOverrides;
    },
    CustomStyleHooksContext_unstable: function() {
        return _CustomStyleHooksContext.CustomStyleHooksContext;
    },
    CustomStyleHooksProvider_unstable: function() {
        return _CustomStyleHooksContext.CustomStyleHooksProvider;
    },
    useCustomStyleHook_unstable: function() {
        return _CustomStyleHooksContext.useCustomStyleHook;
    },
    BackgroundAppearanceProvider: function() {
        return _BackgroundAppearanceContext.BackgroundAppearanceProvider;
    },
    useBackgroundAppearance: function() {
        return _BackgroundAppearanceContext.useBackgroundAppearance;
    },
    PortalMountNodeProvider: function() {
        return _PortalMountNodeContext.PortalMountNodeProvider;
    },
    usePortalMountNode: function() {
        return _PortalMountNodeContext.usePortalMountNode;
    },
    AnnounceProvider: function() {
        return _AnnounceContext.AnnounceProvider;
    },
    AnnounceProvider_unstable: function() {
        return /** @deprecated Use AnnounceProvider instead. */ _AnnounceContext.AnnounceProvider;
    },
    useAnnounce: function() {
        return _AnnounceContext.useAnnounce;
    },
    useAnnounce_unstable: function() {
        return /** @deprecated Use useAnnounce instead. */ _AnnounceContext.useAnnounce;
    }
});
const _ThemeContext = require("./ThemeContext");
const _ThemeClassNameContext = require("./ThemeClassNameContext");
const _TooltipVisibilityContext = require("./TooltipVisibilityContext");
const _ProviderContext = require("./ProviderContext");
const _OverridesContext = require("./OverridesContext");
const _CustomStyleHooksContext = require("./CustomStyleHooksContext");
const _BackgroundAppearanceContext = require("./BackgroundAppearanceContext");
const _PortalMountNodeContext = require("./PortalMountNodeContext");
const _AnnounceContext = require("./AnnounceContext");
